export default "__VITE_ASSET__6a75ff80__"